(function($) {
  "use strict";
  $(".mobile-toggle").click(function(){
    $(".nav-menus").toggleClass("open");
  });
  $(".mobile-toggle-left").click(function(){
    $(".left-header").toggleClass("open");
  });
  $(".mobile-search").click(function(){
     $(".form-control-plaintext").toggleClass("open");
   });
  $(".bookmark-search").click(function(){
    $(".form-control-search").toggleClass("open");
  })
  $(".filter-toggle").click(function(){
    $(".product-sidebar").toggleClass("open");
  });
  $(".toggle-data").click(function(){
    $(".product-wrapper").toggleClass("sidebaron");
  });
  $(".form-control-search").keyup(function(e){
    if(e.target.value) {
      $(".page-wrapper.horizontal-wrapper").addClass("offcanvas-bookmark");
    } else {
      $(".page-wrapper.horizontal-wrapper").removeClass("offcanvas-bookmark");
    }
  });
})(jQuery);

$(window).on('scroll', function() {
  if ($(this).scrollTop() > 600) {
    $('.tap-top').fadeIn();
  } else {
    $('.tap-top').fadeOut();
  }
});

$('.tap-top').click( function() {
  $("html, body").animate({
    scrollTop: 0
  }, 600);
  return false;
});

$(document).ready(function() {
  const phoneInputs = document.getElementsByClassName("phone_input");
  const phoneInputMask = new Inputmask("+9(999)999-99-99", { jitMasking: true });
  phoneInputMask.mask(phoneInputs);

  const emailInputs = document.getElementsByClassName("email_input");
  const emailInputMask = new Inputmask("email", { jitMasking: true });
  emailInputMask.mask(emailInputs);
});